/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.space.applyWrites'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  space: /*#__PURE__*/ l.string(),
  repo: /*#__PURE__*/ l.string({ format: 'did' }),
  validate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  writes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<Create>((() => create) as any),
        /*#__PURE__*/ l.typedRef<Update>((() => update) as any),
        /*#__PURE__*/ l.typedRef<Delete$0>((() => delete$0) as any),
      ],
      true,
    ),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  results: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<CreateResult>((() => createResult) as any),
          /*#__PURE__*/ l.typedRef<UpdateResult>((() => updateResult) as any),
          /*#__PURE__*/ l.typedRef<DeleteResult>((() => deleteResult) as any),
        ],
        true,
      ),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Apply a batch transaction of creates, updates, and deletes in a permissioned space. Requires auth, implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'SpaceNotFound',
  'RecordNotFound',
  'RecordAlreadyExists',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Operation which creates a new record. */
type Create = {
  $type?: 'com.atproto.space.applyWrites#create'
  collection: l.NsidString
  rkey?: l.RecordKeyString
  value: l.LexMap
}

export type { Create }

/** Operation which creates a new record. */
const create = /*#__PURE__*/ l.typedObject<Create>(
  $nsid,
  'create',
  /*#__PURE__*/ l.object({
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'record-key', maxLength: 512 }),
    ),
    value: /*#__PURE__*/ l.lexMap(),
  }),
)

export { create }

/** Operation which updates an existing record. */
type Update = {
  $type?: 'com.atproto.space.applyWrites#update'
  collection: l.NsidString
  rkey: l.RecordKeyString
  value: l.LexMap
}

export type { Update }

/** Operation which updates an existing record. */
const update = /*#__PURE__*/ l.typedObject<Update>(
  $nsid,
  'update',
  /*#__PURE__*/ l.object({
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    value: /*#__PURE__*/ l.lexMap(),
  }),
)

export { update }

/** Operation which deletes an existing record. */
type Delete$0 = {
  $type?: 'com.atproto.space.applyWrites#delete'
  collection: l.NsidString
  rkey: l.RecordKeyString
}

export type { Delete$0 as Delete }

/** Operation which deletes an existing record. */
const delete$0 = /*#__PURE__*/ l.typedObject<Delete$0>(
  $nsid,
  'delete',
  /*#__PURE__*/ l.object({
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
  }),
)

export { delete$0 as 'delete' }

type CreateResult = {
  $type?: 'com.atproto.space.applyWrites#createResult'
  uri: string
  cid: l.CidString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { CreateResult }

const createResult = /*#__PURE__*/ l.typedObject<CreateResult>(
  $nsid,
  'createResult',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string(),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    validationStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { createResult }

type UpdateResult = {
  $type?: 'com.atproto.space.applyWrites#updateResult'
  uri: string
  cid: l.CidString
  validationStatus?: 'valid' | 'unknown' | l.UnknownString
}

export type { UpdateResult }

const updateResult = /*#__PURE__*/ l.typedObject<UpdateResult>(
  $nsid,
  'updateResult',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string(),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    validationStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['valid', 'unknown'] }>(),
    ),
  }),
)

export { updateResult }

type DeleteResult = { $type?: 'com.atproto.space.applyWrites#deleteResult' }

export type { DeleteResult }

const deleteResult = /*#__PURE__*/ l.typedObject<DeleteResult>(
  $nsid,
  'deleteResult',
  /*#__PURE__*/ l.object({}),
)

export { deleteResult }
